
import { Vue, Options } from "vue-class-component";
import {
  INTERNET_ERROR,
  INTERNAL_SERVER_ERROR
} from "@/app/infrastructures/misc/Utils";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import {
  ListTicketPusatResolusiRequest,
  CheckTicketPusatResolusiRequest,
  TicketCounterPusatResolusiRequest
} from "@/data/payload/api/PusatResolusiV2ApiRequest";
import {
  ListTicketPusatResolusi,
  PusatResolusiFilter,
  PusatResolusiFilterTemp
} from "@/domain/entities/PusatResolusiV2";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import Checkbox from "primevue/checkbox";
import { OptionsClass } from "@/domain/entities/MainApp";
import { PaginationV2 } from "@/domain/entities/Pagination";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { mappingListPriority } from "../utils/status-mapping";
import ModalTicketReview from "@/app/ui/views/pusat-resolusi-v2/detail/components/modal-ticket-review.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { FlagsPermissionPusatResolusiV2 } from "@/feature-flags/flags-pusat-resolusi-v2";

const filter = {
  needToBeSolved: false,
  newMessage: false,
  mention: false,
  needToReview: false,
  category: [] as string[],
  status: [] as string[],
  prioritas: [] as string[],
  sort: "asc",
  countNeedToBeSolved: 0,
  countNewMessage: 0,
  countMention: 0,
  countNeedToReview: 0,
  search: "",
  startDate: "",
  endDate: "",
  isClaim: false
};

interface FilterItem {
  label: string;
  type: string;
  flag: keyof typeof PusatResolusiV2Controller.filter;
  countKey: keyof typeof PusatResolusiV2Controller.filter;
  disable: boolean;
  showButton: boolean;
}

interface SelectedTicketItem {
  reviewType: string;
  ticketId: number;
  ticketNo: string;
}

@Options({
  components: {
    Skeleton,
    CustomDropdown,
    Checkbox,
    ModalTicketReview
  }
})
export default class PusatResolusiV2TabTicket extends Vue {
  INTERNAL_SERVER_ERROR = INTERNAL_SERVER_ERROR;
  INTERNET_ERROR = INTERNET_ERROR;
  errorState = "";
  tabLoading = false;
  loading = false;
  openFilterSort = false;
  isOpenModalReview = false;
  selectedTicket: SelectedTicketItem = {
    reviewType: "",
    ticketId: 0,
    ticketNo: ""
  };
  tabs = [
    {
      name: "ticket_escalate",
      titleKey: "pusatResolusi.tabEscalate",
      isNotif: false,
      id: "tab_list_table_tiket_eskalasi",
      idNotif: "new_escalate_ticket"
    },
    {
      name: "my_ticket",
      titleKey: "pusatResolusi.tabMyTicket",
      isNotif: false,
      id: "tab_list_table_tiket_saya",
      idNotif: "new_notification_and_mention_ticket_saya"
    },
    {
      name: "ticket_followed",
      titleKey: "pusatResolusi.tabFollowed",
      isNotif: false,
      id: "tab_list_table_tiket_diikuti",
      idNotif: "new_notification_and_mention_followed_ticket"
    }
  ];

  get filter() {
    return PusatResolusiV2Controller.filter;
  }

  get tempFilterTicket() {
    return PusatResolusiV2Controller.tempFilterTicket;
  }

  get tabActive() {
    return PusatResolusiV2Controller.tabActive;
  }

  set tabActive(val: string) {
    PusatResolusiV2Controller.setActiveTab(val);
  }

  onSearch(value: string) {
    this.dataListTicket.pagination.page = 1;
    this.filter.search = value;
    this.tempFilterTicketSearch();
    this.getListTicket();
  }

  clearSearch() {
    this.filter.search = "";
    this.tempFilterTicketSearch();
    this.getListTicket();
  }

  created() {
    const tab = this.$route.name?.toString() ?? "";
    if (!this.tabActive) {
      this.changeTabs(tab);
    }
  }

  mounted() {
    if (!this.isInternal) {
      this.getTicketCounter("ticket_escalate");
      this.getTicketCounter("my_ticket");
      this.getTicketCounter("ticket_followed");
    }
    this.getListCategory();
    this.getListTicket();
  }

  get disableFilterButton() {
    return (
      !this.filter.category.length &&
      !this.filter.status.length &&
      !this.filter.prioritas.length &&
      !this.filter.isClaim
    );
  }

  get filterButtons(): FilterItem[] {
    return [
      {
        label: this.$t("pusatResolusi.needToBeSolved") as string,
        type: "need_to_be_solved",
        flag: "needToBeSolved",
        countKey: "countNeedToBeSolved",
        disable: this.tabActive === "ticket_escalate",
        showButton: this.tabActive === "ticket_escalate"
      },
      {
        label: this.$t("pusatResolusi.newMessage") as string,
        type: "new_message",
        flag: "newMessage",
        countKey: "countNewMessage",
        disable: false,
        showButton: true
      },
      {
        label: this.$t("pusatResolusi.mention") as string,
        type: "mention",
        flag: "mention",
        countKey: "countMention",
        disable: false,
        showButton: true
      },
      {
        label: this.$t("pusatResolusi.needReview") as string,
        type: "need_to_review",
        flag: "needToReview",
        countKey: "countNeedToReview",
        disable: false,
        showButton: this.tabActive === "my_ticket"
      }
    ];
  }

  get emptyHeaderMessage() {
    return this.errorState === INTERNET_ERROR
      ? this.$t("pusatResolusi.emptyInternet")
      : this.errorState === INTERNAL_SERVER_ERROR
      ? this.$t("pusatResolusi.emptyServer")
      : this.errorState === "no_data"
      ? this.$t("pusatResolusi.emptyNoData")
      : this.$t("pusatResolusi.emptySearchNotFound");
  }

  get emptyMessage() {
    return this.errorState === INTERNET_ERROR
      ? this.$t("pusatResolusi.emptyInternetDesc")
      : this.errorState === INTERNAL_SERVER_ERROR
      ? this.$t("pusatResolusi.emptyServerDesc")
      : this.errorState === "no_data"
      ? this.$t("pusatResolusi.emptyNoDataDesc")
      : this.$t("pusatResolusi.emptySearchDesc");
  }

  get iconEmpty() {
    return this.errorState === INTERNET_ERROR
      ? "error-internet"
      : this.errorState === INTERNAL_SERVER_ERROR
      ? "error-token-ngen"
      : this.errorState === "no_data"
      ? "box_no_data"
      : "ill_spot_search";
  }

  get statusOptions() {
    return [
      { name: this.$t("pusatResolusi.history.new"), value: "NEW" },
      { name: this.$t("pusatResolusi.history.dalamProses"), value: "WORKING" },
      { name: this.$t("pusatResolusi.history.ticketInEscalation"), value: "ESCALATED" },
      { name: this.$t("pusatResolusi.history.ditundaSementara"), value: "ON HOLD" },
      { name: this.$t("pusatResolusi.history.direspon"), value: "SOLVED" },
      { name: this.$t("pusatResolusi.history.selesai"), value: "RESOLVED" },
      { name: this.$t("pusatResolusi.history.ditutup"), value: "CLOSED" },
      { name: this.$t("pusatResolusi.history.menungguDokumen"), value: "DOCUMENT REQUIRED" },
      { name: this.$t("pusatResolusi.history.dokumenDiterima"), value: "DOCUMENT RECEIVED" },
      { name: this.$t("pusatResolusi.history.dalamInvestigasi"), value: "INVESTIGATION" },
      { name: this.$t("pusatResolusi.history.diprosesAsuransi"), value: "INSURANCE" },
      { name: this.$t("pusatResolusi.history.konfirmasiCustomer"), value: "CUSTOMER CONFIRMATION" },
      { name: this.$t("pusatResolusi.history.dibayar"), value: "PAID" },
      { name: this.$t("pusatResolusi.history.ditolak"), value: "REJECT" },
      { name: this.$t("pusatResolusi.history.rekonsiliasi"), value: "RECONCILE" }
    ];
  }

  get priorityOptions() {
    return [
      { name: "Hard complaint", value: "HARD COMPLAINT" },
      { name: "Agregator", value: "AGREGATOR" },
      { name: "Diamond", value: "DIAMOND" },
      { name: "Marketplace", value: "MARKETPLACE" },
      { name: "Corporate", value: "CORPORATE" },
      { name: "CUST Platinum", value: "CUST PLATINUM" },
      { name: "CUST Gold", value: "CUST GOLD" },
      { name: "CUST Silver", value: "CUST SILVER" },
      { name: "CUST Bronze", value: "CUST BRONZE" },
      { name: "POS Diamond", value: "POS DIAMOND" },
      { name: "POS Platinum", value: "POS PLATINUM" },
      { name: "POS Gold", value: "POS GOLD" },
      { name: "POS Silver", value: "POS SILVER" },
      { name: "POS Bronze", value: "POS BRONZE" }
    ];
  }

  get ticketTypeOptions() {
    return [
      {
        name: this.$t("pusatResolusi.history.klaim"),
        value: true
      }
    ];
  }

  get filterLength() {
    const claimCounter = this.filter.isClaim ? 1 : 0;
    return (
      this.filter.category?.length +
      this.filter.status?.length +
      this.filter.prioritas?.length +
      claimCounter
    );
  }

  get filterSortSelected() {
    return this.filter.sort === "asc"
      ? this.$t("pusatResolusi.sortOldest")
      : this.$t("pusatResolusi.sortNewest");
  }

  currentPriority(priority: string) {
    return mappingListPriority(priority.toUpperCase());
  }

  get columns() {
    return [...this.columnFirst, ...this.columnSecond];
  }

  handleTiketRead(isRead: boolean) {
    if (!isRead) {
      return "bg-gray-lp-1200";
    }
  }

  get columnFirst() {
    return [
      {
        name: this.$t("pusatResolusi.columnIssueNo") as string,
        styleHead: "w-40 text-left whitespace-no-wrap break-all mx-3",
        render: (item: any) => {
          return `
              <div class="text-sm text-gray-lp-300 mx-3 break-all">
                ${
                  item.needToBeSolved
                    ? `<div class="bg-red-lp-100 text-white font-bold px-1 absolute left-0 top-0 flex items-center justify-center" style="font-size: 10px; border-radius: 0 0 10px 0; height: 16px;">${this.$t(
                        "pusatResolusi.badgeNeedToSolve"
                      )}</div>`
                    : item.isClaim
                    ? `<div class="bg-aqua-lp-300 text-white font-bold px-1 absolute left-0 top-0 flex items-center justify-center" style="font-size: 10px; border-radius: 0 0 10px 0; height: 16px;">${this.$t(
                        "pusatResolusi.badgeClaim"
                      )}</div>`
                    : ""
                }
                <div class="flex items-center gap-2">
                  <span>
                    ${item?.issueNo || "-"}
                  </span>
                  <div class="flex items-center gap-1">
                    ${
                      item.unreadMessage
                        ? this.handleIconTicket("chat-warning")
                        : ""
                    }
                    ${item.mentioned ? this.handleIconTicket("mention") : ""}
                  </div>
                </div>
              </div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: this.$t("pusatResolusi.columnSttShipment") as string,
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm text-gray-lp-300 break-words">
            ${item?.sttOrShipmentNumber || "-"}
          </div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: this.$t("pusatResolusi.columnCategory") as string,
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm text-gray-lp-300" style="line-height: 112%">${item?.categoryIssue ||
            "-"}</div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: this.$t("pusatResolusi.columnPriority") as string,
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm font-medium px-2 py-0.5 rounded-md ${
            this.currentPriority(item.ticketPriority).bgColor
          } ${this.currentPriority(item.ticketPriority).color}">${
            this.currentPriority(item.ticketPriority)?.label
          }</div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      }
    ];
  }

  get columnSecond() {
    return [
      {
        name: this.$t("pusatResolusi.columnStatus") as string,
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm font-medium ${item?.statusData.text} ${
            item?.statusData.background
          } border ${item?.statusData.border} rounded-2xl px-2 py-0.5">${item
            ?.statusData.label ? this.$t(`${item
            ?.statusData.label}`) : "-"}</div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: this.$t("pusatResolusi.columnCreatedAt") as string,
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-sm text-gray-lp-300">
                    <div style="height: 34px; line-height: 112%; vertical-align: middle;">
                        ${formatDate(item.createdAt)}
                    </br><span class="text-gray-lp-600">
                        ${item?.createdBy || "-"}
                    </span>
                    </div>
                </div>`;
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      },
      {
        name: this.$t("pusatResolusi.columnAction") as string,
        styleHead: "w-16 text-left whitespace-no-wrap",
        key: "double_button_column",
        styleButton: (item: any) => {
          if (this.tabActive === "ticket_escalate") {
            if (item.eligibleAction === "view") {
              return {
                flat: true,
                compact: true,
                class: "w-full",
                icon: "ics_o_eye_red",
                clickFunction: () => {
                  this.$router.push(`/pusat-resolusi-v2/detail/${item.id}`);
                }
              };
            } else if (item.eligibleAction === "assign_to_me") {
              return {
                flat: true,
                compact: true,
                class: "w-full",
                icon: "ics_o_document_red",
                clickFunction: () => {
                  this.$router.push(`/pusat-resolusi-v2/detail/${item.id}`);
                }
              };
            } else if (
              item.eligibleAction === "ineligible_to_assign" ||
              item.eligibleAction === "assigned"
            ) {
              const messageTooltip = this.$t("pusatResolusi.escalatedBy", {
                name: item.assignToUsername
              }) as string;
              return {
                flat: true,
                compact: true,
                class: "w-full",
                icon: "ics_o_document_gray",
                toolTip: messageTooltip
              };
            }
          } else if (
            this.tabActive === "my_ticket" ||
            this.tabActive === "ticket_followed" ||
            this.tabActive === "pusat-resolusi-v2-list-ticket"
          ) {
            return {
              flat: true,
              compact: true,
              class: "w-full",
              icon: "ics_o_eye_red",
              clickFunction: () => {
                this.$router.push(`/pusat-resolusi-v2/detail/${item.id}`);
              }
            };
          }
        },
        styleButtonTwo: (item: any) => {
          return {
            flat: true,
            compact: true,
            class: "w-full",
            customClass: "pr-2",
            icon: item.eligibleReview
              ? this.handleIconReview(item.reviewType, item.isExpiredReview)
              : "",
            sizeIcon: !item.reviewType ? "32px" : "24px",
            toolTip:
              item.eligibleReview && item.isExpiredReview && !item.reviewType
                ? (this.$t("pusatResolusi.tooltipReviewExpired") as string)
                : "",
            toolTipBackground: "#4D4D4D",
            toolTipTextColor: "#ffffff",
            clickFunction: () => {
              if (
                !item.reviewType &&
                item.eligibleReview &&
                !item.isExpiredReview
              ) {
                this.isOpenModalReview = true;
                this.selectedTicket = {
                  reviewType: "",
                  ticketId: item.id,
                  ticketNo: item.issueNo
                };
              }
            }
          };
        },
        advancedStyle: (item: any) => this.handleTiketRead(item.unreadMessage)
      }
    ];
  }

  handleIconReview(reviewType: string, isExpiredReview: boolean) {
    if (!reviewType) {
      if (isExpiredReview) {
        return "thumb_up_&_thumb_down_disable";
      } else {
        return "thumb_up_&_thumb_down";
      }
    } else if (reviewType === "good") {
      return "ics_f_thumb-good";
    } else if (reviewType === "neutral") {
      return "ics_f_thumb-neutral";
    } else if (reviewType === "bad") {
      return "ics_f_thumb-bad";
    }
  }

  get firstRowHeaderColumns() {
    const temp: Array<any> = [
      {
        name: this.$t("pusatResolusi.columnIssueNo"),
        styleHead: "w-40 text-left whitespace-no-wrap break-all"
      },
      {
        name: this.$t("pusatResolusi.columnSttShipment"),
        styleHead: "w-50 text-left whitespace-no-wrap"
      },
      {
        name: this.$t("pusatResolusi.columnCategory"),
        styleHead: "w-48 text-left whitespace-no-wrap"
      },
      {
        name: this.$t("pusatResolusi.columnPriority"),
        styleHead: "w-40 text-left whitespace-no-wrap"
      },
      {
        name: this.$t("pusatResolusi.columnStatus"),
        styleHead: "w-48 text-left whitespace-no-wrap"
      },
      {
        name: this.$t("pusatResolusi.columnCreatedAt"),
        styleHead: "w-48 text-left whitespace-no-wrap"
      },
      {
        name: this.$t("pusatResolusi.columnAction"),
        styleHead: "w-16 text-left whitespace-no-wrap"
      }
    ];
    return temp;
  }

  handleIconTicket(iconType: string) {
    if (iconType === "mention") {
      return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.16699 7.00008C1.16699 10.2142 3.78616 12.8334 7.00033 12.8334C8.27199 12.8334 9.48533 12.4309 10.5003 11.6667C10.757 11.4742 10.8095 11.1067 10.617 10.8501C10.4245 10.5934 10.057 10.5409 9.80033 10.7334C8.98949 11.3459 8.02116 11.6667 7.00033 11.6667C4.42783 11.6667 2.33366 9.57258 2.33366 7.00008C2.33366 4.42758 4.42783 2.33341 7.00033 2.33341C9.57283 2.33341 11.667 4.42758 11.667 7.00008C11.667 7.48425 11.2762 7.87508 10.792 7.87508C10.3078 7.87508 9.91699 7.48425 9.91699 7.00008C9.91699 5.39008 8.61033 4.08342 7.00033 4.08342C5.39033 4.08342 4.08366 5.39008 4.08366 7.00008C4.08366 8.61008 5.39033 9.91675 7.00033 9.91675C8.03937 9.91675 8.95208 9.37252 9.46875 8.55375C9.82537 8.85793 10.2876 9.04175 10.792 9.04175C11.9178 9.04175 12.8337 8.12592 12.8337 7.00008C12.8337 3.78591 10.2145 1.16675 7.00033 1.16675C3.78616 1.16675 1.16699 3.78591 1.16699 7.00008ZM8.75033 7.00008C8.75033 6.03758 7.96283 5.25008 7.00033 5.25008C6.03783 5.25008 5.25033 6.03758 5.25033 7.00008C5.25033 7.96258 6.03783 8.75008 7.00033 8.75008C7.96283 8.75008 8.75033 7.96258 8.75033 7.00008Z" fill="#B82025"/></svg>';
    } else if (iconType === "chat-warning") {
      return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.91699 1.16675C1.95049 1.16675 1.16699 1.95025 1.16699 2.91675V8.76953C1.16699 9.73602 1.95049 10.5195 2.91699 10.5195H3.79199V12.2501C3.79199 12.4691 3.91464 12.6696 4.10959 12.7694C4.30454 12.8691 4.53893 12.8513 4.71655 12.7232L7.77207 10.5195H11.0837C12.0502 10.5195 12.8337 9.73602 12.8337 8.76953V2.91675C12.8337 1.95025 12.0502 1.16675 11.0837 1.16675H2.91699ZM7.57785 4.08342C7.57785 3.76125 7.31799 3.50008 6.99742 3.50008C6.67686 3.50008 6.41699 3.76125 6.41699 4.08342V5.83342C6.41699 6.15558 6.67686 6.41675 6.99742 6.41675C7.31799 6.41675 7.57785 6.15558 7.57785 5.83342V4.08342ZM6.99742 7.00008C6.67686 7.00008 6.41699 7.26125 6.41699 7.58342C6.41699 7.90558 6.67686 8.16675 6.99742 8.16675H7.00323C7.32379 8.16675 7.58366 7.90558 7.58366 7.58342C7.58366 7.26125 7.32379 7.00008 7.00323 7.00008H6.99742Z" fill="#B82025"/></svg>';
    }
  }

  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }

  // category
  listCategory: OptionsClass[] = [];
  async getListCategory() {
    try {
      this.listCategory = [];
      const res = await PusatResolusiV2Controller.getListCategory(
        new CheckTicketPusatResolusiRequest({
          isEn: this.isAccountForeign
        })
      );

      // sort by disabled
      const data = res.map(
        (item) =>
          new OptionsClass({
            name: item.label,
            value: item.code,
            label: item.template, // label as template data
            disabled: !item.isEligible
          })
      );
      this.listCategory = data.sort((a, b) => {
        if (!!a.disabled === !!b.disabled) return 0;
        if (a.disabled && !b.disabled) return 1;
        return -1;
      });
    } catch (error) {
      return error;
    }
  }

  hubIdValue(tab: string) {
    // return tab === "ticket_escalate" ? getHubData()?.hubId || "0" : "0";
    return getHubData()?.hubId || "0";
  }

  async getTicketCounter(tab: string) {
    try {
      const notificationTicket = await PusatResolusiV2Controller.getTicketCounter(
        new TicketCounterPusatResolusiRequest({
          ticketType: tab,
          hubId: this.hubIdValue(tab)
        })
      );

      if (this.tabActive === tab) {
        this.filter.countNeedToBeSolved =
          notificationTicket?.countTicketNeedToBeSolved || 0;
        this.filter.countNewMessage = notificationTicket?.countNewMessage || 0;
        this.filter.countMention = notificationTicket?.countMention || 0;
        this.filter.countNeedToReview =
          notificationTicket?.countTicketNeedToReview || 0;
      }

      // notif ticket tabs
      this.mapTicketNotif(notificationTicket, tab);
    } catch (error) {
      return error;
    }
  }

  mapTicketNotif(notificationTicket: any, tab: string) {
    this.tabs.map((item) => {
      item.name === tab
        ? (item.isNotif =
            notificationTicket.countNewMessage +
              notificationTicket.countMention >
            0
              ? true
              : false)
        : item;
    });
  }

  get isInternalSearch() {
    return (
      AccountController.accountData.isInternalAccount && this.filter.search
    );
  }

  dataListTicket: ListTicketPusatResolusi = new ListTicketPusatResolusi();
  async getListTicket() {
    this.errorState = "";
    try {
      this.tabLoading = true;
      this.loading = true;
      const response = await PusatResolusiV2Controller.getListTicket(
        new ListTicketPusatResolusiRequest({
          page: this.dataListTicket.pagination.page
            ? this.dataListTicket.pagination.page
            : 1,
          limit: this.dataListTicket.pagination.limit
            ? this.dataListTicket.pagination.limit
            : 20,
          ticketType: this.tabActive,
          needToBeSolved: this.filter.needToBeSolved,
          newMessage: this.filter.newMessage,
          mentioned: this.filter.mention,
          needToReview: this.filter.needToReview,
          sortByDate: this.filter.sort,
          search: this.filter.search,
          categoryIssueCode: this.filter.category.join(","),
          statusTicket: this.filter.status.join(","),
          ticketPriority: this.filter.prioritas.join(","),
          hubId: this.hubIdValue(this.tabActive),
          startDate: this.isInternalSearch ? "" : this.filter.startDate,
          endDate: this.isInternalSearch ? "" : this.filter.endDate,
          isClaim: this.filter.isClaim
        })
      );

      this.dataListTicket = new ListTicketPusatResolusi({
        pagination: new PaginationV2({
          page: response.pagination.page,
          limit: response.pagination.limit,
          totalData: response.pagination.totalData
        }),
        data: response.data
      });

      this.errorState = this.isNoDataKendala();
    } catch (error) {
      this.handleError(error);
    } finally {
      this.tabLoading = false;
      this.loading = false;
    }
  }

  isNoDataKendala() {
    const {
      category,
      status,
      prioritas,
      search,
      newMessage,
      needToBeSolved,
      mention
    } = this.filter;

    const isCommonEmpty =
      !category.length &&
      !status.length &&
      !prioritas.length &&
      !search &&
      !this.dataListTicket.data.length;

    if (this.tabActive === "ticket_escalate") {
      return this.validateNoKendala(
        isCommonEmpty,
        newMessage,
        needToBeSolved,
        mention
      );
    } else {
      return this.validateNoKendala(
        isCommonEmpty,
        newMessage,
        needToBeSolved,
        mention
      );
    }
  }

  validateNoKendala(
    isCommonEmpty: boolean,
    newMessage: boolean,
    needToBeSolved: boolean,
    mention: boolean
  ) {
    return isCommonEmpty && !newMessage ? "no_data" : "";
  }

  handleError(error: any) {
    if (!error?.response) {
      this.errorState = INTERNET_ERROR;
    } else {
      this.errorState = INTERNAL_SERVER_ERROR;
    }
  }

  changeTabs(value: string) {
    this.$router.push({
      name: value
    });
    this.dataListTicket = new ListTicketPusatResolusi();
    this.tabActive = value;
    this.tempFilterTicketFunc(value);
    this.tempFilterTicketSelect();
    this.tempFilterTicketSort();
    this.getTicketCounter(value);
    this.getListTicket();
  }

  tempFilterTicketFunc(tab: string) {
    if (tab === "ticket_escalate") {
      this.filter.needToBeSolved = this.tempFilterTicket.ticketEscalate.needToBeSolved;
      this.filter.newMessage = this.tempFilterTicket.ticketEscalate.newMessage;
      this.filter.mention = this.tempFilterTicket.ticketEscalate.mention;
      this.filter.needToReview = false;
      this.filter.category = this.tempFilterTicket.ticketEscalate.category;
      this.filter.status = this.tempFilterTicket.ticketEscalate.status;
      this.filter.prioritas = this.tempFilterTicket.ticketEscalate.prioritas;
      this.filter.sort = this.tempFilterTicket.ticketEscalate.sort;
      this.filter.search = this.tempFilterTicket.ticketEscalate.search;
      this.filter.isClaim = this.tempFilterTicket.ticketEscalate.isClaim;
    } else if (tab === "my_ticket") {
      this.filter.needToBeSolved = this.tempFilterTicket.myTicket.needToBeSolved;
      this.filter.newMessage = this.tempFilterTicket.myTicket.newMessage;
      this.filter.mention = this.tempFilterTicket.myTicket.mention;
      this.filter.needToReview = this.tempFilterTicket.myTicket.needToReview;
      this.filter.category = this.tempFilterTicket.myTicket.category;
      this.filter.status = this.tempFilterTicket.myTicket.status;
      this.filter.prioritas = this.tempFilterTicket.myTicket.prioritas;
      this.filter.sort = this.tempFilterTicket.myTicket.sort;
      this.filter.search = this.tempFilterTicket.myTicket.search;
      this.filter.isClaim = this.tempFilterTicket.myTicket.isClaim;
    } else if (tab === "ticket_followed") {
      this.filter.needToBeSolved = this.tempFilterTicket.ticketFollowed.needToBeSolved;
      this.filter.newMessage = this.tempFilterTicket.ticketFollowed.newMessage;
      this.filter.mention = this.tempFilterTicket.ticketFollowed.mention;
      this.filter.needToReview = false;
      this.filter.category = this.tempFilterTicket.ticketFollowed.category;
      this.filter.status = this.tempFilterTicket.ticketFollowed.status;
      this.filter.prioritas = this.tempFilterTicket.ticketFollowed.prioritas;
      this.filter.sort = this.tempFilterTicket.ticketFollowed.sort;
      this.filter.search = this.tempFilterTicket.ticketFollowed.search;
      this.filter.isClaim = this.tempFilterTicket.ticketFollowed.isClaim;
    }
  }

  isTabActive(name: string) {
    return name === this.tabActive;
  }

  resetFilter() {
    this.filter.category = [];
    this.filter.status = [];
    this.filter.prioritas = [];
    this.filter.isClaim = false;
    this.dataListTicket.pagination.page = 1;
    this.tempFilterTicketSelect();
    this.getListTicket();
    const filterRef: any = this.$refs.advancedFilter;
    filterRef.closeFilter();
  }

  filterTicket(value: string) {
    if (value === "need_to_be_solved") {
      this.filter.needToBeSolved = !this.filter.needToBeSolved;
    } else if (value === "new_message") {
      this.filter.newMessage = !this.filter.newMessage;
    } else if (value === "mention") {
      this.filter.mention = !this.filter.mention;
    } else if (value === "need_to_review") {
      this.filter.needToReview = !this.filter.needToReview;
    }

    this.dataListTicket.pagination.page = 1;
    this.filterTicketTemp();
    this.getListTicket();
  }

  filterTicketTemp() {
    if (this.tabActive === "ticket_escalate") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketEscalate: {
            ...this.tempFilterTicket.ticketEscalate,
            needToBeSolved: this.filter.needToBeSolved,
            newMessage: this.filter.newMessage,
            mention: this.filter.mention
          }
        })
      );
    } else if (this.tabActive === "my_ticket") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          myTicket: {
            ...this.tempFilterTicket.myTicket,
            needToBeSolved: this.filter.needToBeSolved,
            newMessage: this.filter.newMessage,
            mention: this.filter.mention,
            needToReview: this.filter.needToReview
          }
        })
      );
    } else if (this.tabActive === "ticket_followed") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketFollowed: {
            ...this.tempFilterTicket.ticketFollowed,
            needToBeSolved: this.filter.needToBeSolved,
            newMessage: this.filter.newMessage,
            mention: this.filter.mention
          }
        })
      );
    }
  }

  tempFilterTicketSelect() {
    if (this.tabActive === "ticket_escalate") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketEscalate: {
            ...this.tempFilterTicket.ticketEscalate,
            category: this.filter.category,
            status: this.filter.status,
            prioritas: this.filter.prioritas,
            isClaim: this.filter.isClaim
          }
        })
      );
    } else if (this.tabActive === "my_ticket") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          myTicket: {
            ...this.tempFilterTicket.myTicket,
            category: this.filter.category,
            status: this.filter.status,
            prioritas: this.filter.prioritas,
            isClaim: this.filter.isClaim
          }
        })
      );
    } else if (this.tabActive === "ticket_followed") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketFollowed: {
            ...this.tempFilterTicket.ticketFollowed,
            category: this.filter.category,
            status: this.filter.status,
            prioritas: this.filter.prioritas,
            isClaim: this.filter.isClaim
          }
        })
      );
    }
  }

  tempFilterTicketSort() {
    if (this.tabActive === "ticket_escalate") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketEscalate: {
            ...this.tempFilterTicket.ticketEscalate,
            sort: this.filter.sort
          }
        })
      );
    } else if (this.tabActive === "my_ticket") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          myTicket: {
            ...this.tempFilterTicket.myTicket,
            sort: this.filter.sort
          }
        })
      );
    } else if (this.tabActive === "ticket_followed") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketFollowed: {
            ...this.tempFilterTicket.ticketFollowed,
            sort: this.filter.sort
          }
        })
      );
    }
  }

  tempFilterTicketSearch() {
    if (this.tabActive === "ticket_escalate") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketEscalate: {
            ...this.tempFilterTicket.ticketEscalate,
            search: this.filter.search
          }
        })
      );
    } else if (this.tabActive === "my_ticket") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          myTicket: {
            ...this.tempFilterTicket.myTicket,
            search: this.filter.search
          }
        })
      );
    } else if (this.tabActive === "ticket_followed") {
      PusatResolusiV2Controller.setFilterTemp(
        new PusatResolusiFilterTemp({
          ...this.tempFilterTicket,
          ticketFollowed: {
            ...this.tempFilterTicket.ticketFollowed,
            search: this.filter.search
          }
        })
      );
    }
  }

  filterSort(sort: string) {
    this.filter.sort = sort;
    this.dataListTicket.pagination.page = 1;
    this.tempFilterTicketSort();
    this.getListTicket();
    this.openFilterSort = false;
  }

  filterSelect() {
    this.dataListTicket.pagination.page = 1;
    this.tempFilterTicketSelect();
    this.getListTicket();
    const filterRef: any = this.$refs.advancedFilter;
    filterRef.closeFilter();
  }

  get isInternal() {
    return AccountController.accountData.isInternalAccount;
  }

  setDateRange(value: Array<any>) {
    this.filter.startDate = value[0].toLocaleDateString("fr-CA");
    this.filter.endDate = value[1].toLocaleDateString("fr-CA");
    this.getListTicket();
  }

  get showWidgetDownload(): boolean {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_widget_laporan.isEnabled();
  }
}
